const initialState = {
    isLoading: false,
    processingState: null, // null, 'analyzing', 'detecting', 'scoring', 'generating', 'complete'
    viralClips: [],
    processingProgress: 0
  };
  
  const cmsReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_LOADING':
        return {
          ...state,
          isLoading: action.payload
        };
      case 'SET_PROCESSING_STATE':
        return {
          ...state,
          processingState: action.payload
        };
      case 'UPDATE_PROCESSING_PROGRESS':
        return {
          ...state,
          processingProgress: action.payload
        };
      case 'SET_VIRAL_CLIPS':
        return {
          ...state,
          viralClips: action.payload,
          processingState: 'complete'
        };
      case 'CLEAR_VIDEO_STATE':
        return {
          ...state,
          processingState: null,
          viralClips: [],
          processingProgress: 0
        };
      default:
        return state;
    }
  };
  
  export default cmsReducer;